import styled from 'styled-components';

const HeaderContainer = styled.div`
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 2;
    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        min-height: 97px;
        padding: 0 80px;
        &::after {
            content: '';
            position: absolute;
            height: 1px;
            background-color: #a2a2a2;
            bottom: 0;
            width: calc(100% - 30px);
            left: 15px;
        }
    }
    .logo img {
        height: 40px;
    }
`;

export default HeaderContainer;
